import { installConsoleBuffer } from "./buffers/console";
import { installNetworkBuffer } from "./buffers/network";
import { ArkSnitchElement } from "./element";

// Install buffers as soon as the script loads — earlier is better,
// the goal is to capture logs/requests from before the user opens the modal.
installConsoleBuffer();
installNetworkBuffer();

if (typeof customElements !== "undefined" && !customElements.get("ark-snitch")) {
  customElements.define("ark-snitch", ArkSnitchElement);
}

export { ArkSnitchElement };
export type { ReportPayload, IngestResponse } from "@ark-snitch/shared";
